var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Fill/code-download"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7795 11.373L16.9515 5.373C16.6035 4.943 15.9745 4.873 15.5455 5.221C15.1145 5.567 15.0475 6.196 15.3925 6.627L19.7085 11.989L15.2315 17.359C14.8785 17.784 14.9355 18.415 15.3595 18.769C15.5475 18.924 15.7735 19 15.9995 19C16.2865 19 16.5705 18.878 16.7685 18.641L21.7685 12.641C22.0735 12.274 22.0785 11.744 21.7795 11.373ZM4.29216 12.0107L8.76916 6.6407C9.12216 6.2157 9.06416 5.5847 8.64116 5.2317C8.21516 4.8787 7.58616 4.9357 7.23116 5.3597L2.23116 11.3597C1.92716 11.7257 1.92216 12.2557 2.22116 12.6267L7.04916 18.6267C7.24716 18.8717 7.53616 18.9997 7.82916 18.9997C8.04916 18.9997 8.27116 18.9277 8.45516 18.7797C8.88616 18.4327 8.95316 17.8037 8.60716 17.3727L4.29216 12.0107ZM14.3059 11.3842C14.7019 11.0002 15.3369 11.0132 15.7199 11.4092C16.1029 11.8062 16.0919 12.4392 15.6949 12.8232L12.6949 15.7202C12.5009 15.9062 12.2499 16.0002 11.9999 16.0002C11.7439 16.0002 11.4889 15.9022 11.2929 15.7072L8.29286 12.7072C7.90286 12.3162 7.90286 11.6832 8.29286 11.2932C8.68386 10.9022 9.31686 10.9022 9.70686 11.2932L10.9999 12.5852V8.0002C10.9999 7.4472 11.4479 7.0002 11.9999 7.0002C12.5529 7.0002 12.9999 7.4472 12.9999 8.0002V12.6442L14.3059 11.3842Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_21708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 20,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7795 11.373L16.9515 5.373C16.6035 4.943 15.9745 4.873 15.5455 5.221C15.1145 5.567 15.0475 6.196 15.3925 6.627L19.7085 11.989L15.2315 17.359C14.8785 17.784 14.9355 18.415 15.3595 18.769C15.5475 18.924 15.7735 19 15.9995 19C16.2865 19 16.5705 18.878 16.7685 18.641L21.7685 12.641C22.0735 12.274 22.0785 11.744 21.7795 11.373ZM4.29216 12.0107L8.76916 6.6407C9.12216 6.2157 9.06416 5.5847 8.64116 5.2317C8.21516 4.8787 7.58616 4.9357 7.23116 5.3597L2.23116 11.3597C1.92716 11.7257 1.92216 12.2557 2.22116 12.6267L7.04916 18.6267C7.24716 18.8717 7.53616 18.9997 7.82916 18.9997C8.04916 18.9997 8.27116 18.9277 8.45516 18.7797C8.88616 18.4327 8.95316 17.8037 8.60716 17.3727L4.29216 12.0107ZM14.3059 11.3842C14.7019 11.0002 15.3369 11.0132 15.7199 11.4092C16.1029 11.8062 16.0919 12.4392 15.6949 12.8232L12.6949 15.7202C12.5009 15.9062 12.2499 16.0002 11.9999 16.0002C11.7439 16.0002 11.4889 15.9022 11.2929 15.7072L8.29286 12.7072C7.90286 12.3162 7.90286 11.6832 8.29286 11.2932C8.68386 10.9022 9.31686 10.9022 9.70686 11.2932L10.9999 12.5852V8.0002C10.9999 7.4472 11.4479 7.0002 11.9999 7.0002C12.5529 7.0002 12.9999 7.4472 12.9999 8.0002V12.6442L14.3059 11.3842Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_21708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeDownload);
export default __webpack_public_path__ + "static/media/code-download.e2e375e32709f43600b473a9aab1321b.svg";
export { ForwardRef as ReactComponent };